<!-- 发布专利 -->
<template>
  <div class="home">
    <h1>基础信息</h1>
    <div class="content1">
      <div class="form">
        <ul>
          <li>
            <h2>申请号</h2>
            <input
              v-model="form.application_number"
              type="number"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>专利类别</h2>
            <!-- <input type="text" placeholder="请输入" /> -->
            <div class="sort">
              <el-select
                v-model="form.patent_classification"
                placeholder="请选择"
                :value-key="form.patent_classification.toString()"
              >
                <el-option
                  v-for="item in dropdownOptions.patent_classification"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>专利名称</h2>
            <input v-model="form.title" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>授权类型</h2>
            <!-- <input type="text" placeholder="请输入" /> -->
            <div class="sort">
              <el-select v-model="form.authorization_type" placeholder="请选择">
                <el-option
                  v-for="item in dropdownOptions.authorization_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>专利领域</h2>
            <input v-model="form.field" type="text" placeholder="请输入" />
          </li>

          <li>
            <h2>权利人</h2>
            <input
              v-model="form.right_holder"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>当前权利人</h2>
            <input
              v-model="form.current_right_holder"
              type="text"
              placeholder="请输入"
            />
          </li>
          <!-- <li>
            <h2>当前权利人</h2>
            <input type="text" placeholder="请输入" />
          </li> -->
          <li>
            <h2>代理人</h2>
            <input v-model="form.agent" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>优先权信息</h2>
            <input
              v-model="form.priority_info"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>公开（公告）号</h2>
            <input
              v-model="form.publication_number"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>公开（公告）日</h2>
            <input
              v-model="form.publication_date"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>申请人地址</h2>
            <input
              v-model="form.applicant_address"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>主分类号</h2>
            <input
              v-model="form.main_classification"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>IPC分类号</h2>
            <input
              v-model="form.ipc_classification"
              type="text"
              placeholder="请输入"
            />
          </li>
          <li>
            <h2>发明/设计人</h2>
            <input v-model="form.inventor" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>代理机构</h2>
            <input v-model="form.agency" type="text" placeholder="请输入" />
          </li>
          <!-- <li style="display: flex; flex-direction: row; align-items: center">
            <h2 style="margin-bottom: 0; margin-right: 10px">价格类型:</h2>
            <div style="margin-top: 3px">
              <el-radio-group
                v-model="form.price_type"
                @change="handlePriceTypeChange"
              >
                <el-radio label="negotiable" style="margin-right: 15px"
                  >面议</el-radio
                >
                <el-radio label="fixed">有价格</el-radio>
              </el-radio-group>
            </div>
          </li> -->
          <li>
            <h2>价格类型</h2>
            <div class="sort">
              <el-select
                v-model="form.price_type"
                placeholder="请选择"
                @change="handlePriceTypeChange"
              >
                <el-option label="面议" value="negotiable" />
                <el-option label="有价格" value="fixed" />
              </el-select>
            </div>
          </li>
          <li v-if="form.price_type === 'fixed'">
            <h2>专利价格</h2>
            <input v-model="form.price" type="number" placeholder="请输入" />
          </li>
        </ul>
      </div>
      <div class="editor">
        <li><span>摘要</span><RichTextEditor ref="abstractEditor" /></li>
        <li><span>法律状态</span><RichTextEditor ref="legalStatusEditor" /></li>
        <li><span>权利要求</span><RichTextEditor ref="claimsEditor" /></li>
        <li><span>说明书</span><RichTextEditor ref="descriptionEditor" /></li>
      </div>
      <div class="footer">
        <li>
          <h2>附图</h2>
          <input
            type="file"
            multiple
            @change="handleDrawingsUpload"
            style="display: none"
            ref="drawingsInput"
            accept="image/*"
          />
          <div class="image-upload-container">
            <div
              class="upload-placeholder"
              @click="$refs.drawingsInput.click()"
            >
              <img src="../../assets/uploadPictures.png" alt="上传附图" />
            </div>
            <div
              class="image-preview"
              v-for="(img, index) in form.drawings"
              :key="index"
            >
              <img :src="getImageUrl(img)" alt="附图预览" />
              <span class="delete-btn" @click="removeDrawing(index)">×</span>
            </div>
          </div>
        </li>
        <div class="choice">
          <span>请选择</span>
          <div class="choice_content">
            <el-radio v-model="radio" label="1" style="margin-right: 45px"
              >开放许可</el-radio
            >
            <el-radio v-model="radio" label="2" style="margin-right: 15px"
              >付费许可</el-radio
            >
            <input
              v-model="form.payment_away"
              type="text"
              placeholder="请填写付费方式"
              style="margin-right: 45px"
              :disabled="radio !== '2'"
            />
            <el-radio v-model="radio" label="3" style="margin-right: 15px">
              专利出售
            </el-radio>
            <input
              v-model="form.exclusive_selling_price"
              type="text"
              placeholder="请填写价格或者面谈"
              :disabled="radio !== '3'"
            />
          </div>
        </div>
        <div class="upload">
          <span>上传文件</span>
          <input
            type="file"
            @change="handleAttachmentUpload"
            style="display: none"
            ref="attachmentInput"
          />
          <ul @click="$refs.attachmentInput.click()" style="cursor: pointer">
            <img src="../../assets/update_icon.png" alt="上传文件" />
            <p>上传信息</p>
          </ul>
          <div class="upload-status" v-if="form.attachments">
            已选择文件: {{ form.attachments.name }}
            <el-button
              type="text"
              @click="form.attachments = null"
              style="margin-left: 10px; color: #f56c6c"
            >
              清除
            </el-button>
          </div>
        </div>
        <div class="form">
          <ul>
            <li>
              <h2>产业分类</h2>
              <!-- <input type="text" placeholder="请输入" /> -->
              <div class="sort">
                <el-select
                  v-model="form.industrial_classification"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in dropdownOptions.industrial_classification"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </li>
            <li>
              <h2>案源分类</h2>
              <!-- <input type="text" placeholder="请输入" /> -->
              <div class="sort">
                <el-select
                  v-model="form.classification_of_case_sources"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in dropdownOptions.classification_of_case_sources"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </li>
            <li>
              <h2>专利类型</h2>
              <!-- <input type="text" placeholder="请输入" /> -->
              <div class="sort">
                <el-select v-model="form.patent_type" placeholder="请选择">
                  <el-option
                    v-for="item in dropdownOptions.patent_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </li>
            <li>
              <h2>专利权人</h2>
              <input v-model="form.patentee" type="text" placeholder="请输入" />
            </li>
            <li>
              <h2>许可费用</h2>
              <input
                v-model="form.license_fee"
                type="number"
                placeholder="请输入"
              />
            </li>
            <li>
              <h2>许可支付类型</h2>
              <div class="sort">
                <el-select
                  v-model="form.license_payment_type"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in dropdownOptions.license_payment_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </li>
            <li>
              <h2>单次许可期限</h2>
              <input
                v-model="form.license_term"
                type="text"
                placeholder="请输入"
              />
            </li>
          </ul>
          <li class="borderB">
            <h2>上传轮播图</h2>
            <input
              type="file"
              multiple
              @change="handleCarouselUpload"
              style="display: none"
              ref="carouselInput"
              accept="image/*"
            />
            <div class="image-upload-container">
              <div
                class="upload-placeholder"
                @click="$refs.carouselInput.click()"
              >
                <img src="../../assets/uploadPictures.png" alt="上传轮播图" />
              </div>
              <div
                class="image-preview"
                v-for="(img, index) in form.carousel_images"
                :key="index"
              >
                <img :src="getImageUrl(img)" alt="轮播图预览" />
                <span class="delete-btn" @click="removeCarouselImage(index)"
                  >×</span
                >
              </div>
            </div>
          </li>
        </div>
      </div>
      <div
        class="submit"
        @click="submitForm"
        :disabled="uploadLoading"
        :style="{
          cursor: uploadLoading ? 'not-allowed' : 'pointer',
          background: uploadLoading ? '#cccccc' : '#233cac',
        }"
      >
        {{ uploadLoading ? "提交中..." : "提交" }}
      </div>
    </div>
  </div>
</template>

<script>
// import { content } from "html2canvas/dist/types/css/property-descriptors/content";
import {
  getPublishPatent,
  getUploadImage,
  getUploadFile,
  getParams,
  getMyPatentDetail,
  getUpdatePatent,
} from "../../api/userApi";
import RichTextEditor from "../RichTextEditor.vue";
export default {
  components: { RichTextEditor },
  data() {
    return {
      radio: "1",
      isEditMode: false, // 是否为编辑模式
      currentPatentId: "", // 当前编辑的专利ID
      dropdownOptions: {
        patent_classification: [], // 专利类别
        authorization_type: [], // 授权类型
        industrial_classification: [], // 产业分类
        classification_of_case_sources: [], // 案源分类
        patent_type: [], // 专利类型
        license_payment_type: [], // 许可支付类型
      },
      value: "",
      form: {
        application_number: "",
        patent_classification: "",
        title: "",
        authorization_type: "",
        field: "",
        price_type: "",
        price: "",
        right_holder: "",
        current_right_holder: "",
        agent: "",
        priority_info: "",
        publication_number: "",
        publication_date: "",
        applicant_address: "",
        main_classification: "",
        ipc_classification: "",
        inventor: "",
        agency: "",
        industrial_classification: "",
        classification_of_case_sources: "",
        patent_type: "",
        patentee: "",
        license_fee: "",
        license_payment_type: "",
        license_term: "",
        drawings: [],
        carousel_images: [],
        attachments: null,
        payment_away: "",
        exclusive_selling_price: "",
      },
      uploadLoading: false,
    };
  },
  created() {
    this.fetchDropdownOptions();
    this.checkEditMode();
  },
  methods: {
    handlePriceTypeChange(value) {
      if (value === "negotiable") {
        // 如果选择"面议"，清空价格
        this.form.price = "";
      }
    },
    getImageUrl(img) {
      // 如果是字符串URL，直接返回
      if (typeof img === "string") {
        return img;
      }
      // 如果是File对象，创建临时URL
      if (img instanceof File) {
        return URL.createObjectURL(img);
      }
      // 如果是对象形式的附件，返回其URL
      if (img && img.url) {
        return img.url;
      }
      return "";
    },
    // 检查是否为编辑模式
    checkEditMode() {
      if (this.$route.query.id && this.$route.query.mode === "edit") {
        this.isEditMode = true;
        this.currentPatentId = this.$route.query.id;
        this.fetchPatentDetail();
      }
    },
    // 获取专利详情
    async fetchPatentDetail() {
      try {
        const response = await getMyPatentDetail({ id: this.currentPatentId });
        if (response.code === 1 && response.data) {
          this.populateForm(response.data);
        } else {
          this.$message.error("获取专利详情失败");
        }
      } catch (error) {
        console.error("获取专利详情出错:", error);
        this.$message.error("获取专利详情出错");
      }
    },

    // 填充表单数据
    populateForm(data) {
      // 基础信息
      this.form.application_number = data.application_number || "";
      this.form.patent_classification = String(data.patent_classification);
      this.form.title = data.title || "";
      this.form.authorization_type = String(data.authorization_type);
      this.form.field = data.field || "";
      // this.form.price_type = data.price_type || "";
      this.form.price_type =
        data.price_type === "面议" ? "negotiable" : "fixed";
      this.form.price = data.price || "";
      this.form.right_holder = data.right_holder || "";
      this.form.current_right_holder = data.current_right_holder || "";
      this.form.agent = data.agent || "";
      this.form.priority_info = data.priority_info || "";
      this.form.publication_number = data.publication_number || "";
      this.form.publication_date = data.publication_date || "";
      this.form.applicant_address = data.applicant_address || "";
      this.form.main_classification = data.main_classification || "";
      this.form.ipc_classification = data.ipc_classification || "";
      this.form.inventor = data.inventor || "";
      this.form.agency = data.agency || "";

      // 许可信息
      this.radio = data.license_type || "1";
      this.form.payment_away = data.payment_away || "";
      this.form.exclusive_selling_price = data.exclusive_selling_price || "";

      // 分类信息
      this.form.industrial_classification = String(
        data.industrial_classification
      );
      this.form.classification_of_case_sources = String(
        data.classification_of_case_sources
      );
      this.form.patent_type = String(data.patent_type);
      this.form.license_payment_type = String(data.license_payment_type);
      this.form.patentee = data.patentee || "";
      this.form.license_fee = data.license_fee || "";
      this.form.license_term = data.license_term || "";

      // 富文本内容
      if (this.$refs.abstractEditor && data.abstract) {
        this.$refs.abstractEditor.setContent(data.abstract);
      }
      if (this.$refs.legalStatusEditor && data.legal_status) {
        this.$refs.legalStatusEditor.setContent(data.legal_status);
      }
      if (this.$refs.claimsEditor && data.claims) {
        this.$refs.claimsEditor.setContent(data.claims);
      }
      if (this.$refs.descriptionEditor && data.description) {
        this.$refs.descriptionEditor.setContent(data.description);
      }
      // 处理图片数据
      if (data.drawings) {
        // 将逗号分隔的URL字符串转换为数组
        this.form.drawings = data.drawings
          .split(",")
          .filter((url) => url.trim() !== "");
      }
      if (data.carousel_images) {
        // 将逗号分隔的URL字符串转换为数组
        this.form.carousel_images = data.carousel_images
          .split(",")
          .filter((url) => url.trim() !== "");
      }
      if (data.attachments) {
        // 附件处理
        this.form.attachments = {
          name: data.attachments.split("/").pop() || "附件文件",
          url: data.attachments,
        };
      }
    },
    async fetchDropdownOptions() {
      try {
        const response = await getParams();
        if (response.code === 1 && response.data) {
          const data = response.data;

          // 专利类别
          if (data.patent_classification) {
            this.dropdownOptions.patent_classification =
              data.patent_classification.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
            // this.dropdownOptions.patent_classification =
            //   data.patent_classification.data.map((item) => item.title);
          }
          console.log(
            this.dropdownOptions.patent_classification,
            "this.dropdownOptions.patent_classification"
          );

          // 授权类型
          if (data.authorization_type) {
            this.dropdownOptions.authorization_type =
              data.authorization_type.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }

          // 产业分类
          if (data.industrial_classification) {
            this.dropdownOptions.industrial_classification =
              data.industrial_classification.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }

          // 案源分类
          if (data.classification_of_case_sources) {
            this.dropdownOptions.classification_of_case_sources =
              data.classification_of_case_sources.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }

          // 专利类型
          if (data.patent_type) {
            this.dropdownOptions.patent_type = data.patent_type.data.map(
              (item) => ({
                value: item.id,
                label: item.title,
              })
            );
          }

          // 许可支付类型
          if (data.license_payment_type) {
            this.dropdownOptions.license_payment_type =
              data.license_payment_type.data.map((item) => ({
                value: item.id,
                label: item.title,
              }));
          }
        }
      } catch (error) {
        console.error("获取下拉选项失败:", error);
      }
    },
    getContent() {
      return this.content;
    },
    // 上传图片方法
    async uploadImages(files, type) {
      try {
        if (!files || files.length === 0) return "";

        const uploadedUrls = [];
        for (const file of files) {
          const formData = new FormData();
          formData.append("file", file);

          console.log(`正在上传${type}文件:`, file.name); // 调试日志

          const response = await getUploadImage(formData);
          if (response.data && response.data.url) {
            console.log(`文件上传成功:`, response.data.url); // 调试日志
            uploadedUrls.push(response.data.url);
          } else {
            console.error(`文件上传返回数据异常:`, response);
          }
        }

        const result = uploadedUrls.join(",");
        console.log(`所有${type}上传结果:`, result); // 调试日志
        return result;
      } catch (error) {
        console.error(`上传${type}失败:`, error);
        this.$message.error(
          `${type === "drawings" ? "附图" : "轮播图"}上传失败`
        );
        return "";
      }
    },

    // 上传附件方法
    async uploadAttachment(file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await getUploadFile(formData);
        return response.data?.url || "";
      } catch (error) {
        console.error("上传附件失败:", error);
        this.$message.error("附件上传失败");
        return "";
      }
    },

    // 处理附图上传
    handleDrawingsUpload(event) {
      const files = Array.from(event.target.files);
      if (files.length > 0) {
        this.form.drawings = [...this.form.drawings, ...files];
      }
      event.target.value = ""; // 重置input，允许重复选择相同文件
    },

    // 处理轮播图上传
    handleCarouselUpload(event) {
      const files = Array.from(event.target.files);
      if (files.length > 0) {
        this.form.carousel_images = [...this.form.carousel_images, ...files];
      }
      event.target.value = "";
    },

    // 处理附件上传
    handleAttachmentUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.attachments = file;
      }
      event.target.value = "";
    },

    async submitForm() {
      try {
        console.log("进入了提交表单");

        this.uploadLoading = true;

        // 1. 上传图片和附件
        const uploadResults = await Promise.all([
          this.uploadFiles(this.form.drawings, "drawings"),
          this.uploadFiles(this.form.carousel_images, "carousel"),
          this.uploadFile(this.form.attachments),
        ]);
        const [drawingsUrls, carouselUrls, attachmentUrl] = uploadResults;

        console.log("上传结果:", {
          drawingsUrls,
          carouselUrls,
          attachmentUrl,
        });

        // 2. 准备专利发布数据 - 修改为平级结构
        const patentData = {
          // 基础信息
          application_number: this.form.application_number,
          patent_classification: this.form.patent_classification,
          title: this.form.title,
          authorization_type: this.form.authorization_type,
          // 其他字段...
          field: this.form.field,
          // price_type: this.form.price_type,
          // price: this.form.price,
          price_type: this.form.price_type === "negotiable" ? "面议" : "有价格",
          price:
            this.form.price_type === "negotiable" ? "面议" : this.form.price,
          right_holder: this.form.right_holder,
          current_right_holder: this.form.current_right_holder,
          agent: this.form.agent,
          priority_info: this.form.priority_info,
          publication_number: this.form.publication_number,
          publication_date: this.form.publication_date,
          applicant_address: this.form.applicant_address,
          main_classification: this.form.main_classification,
          ipc_classification: this.form.ipc_classification,
          inventor: this.form.inventor,
          agency: this.form.agency,

          // 图片和附件
          drawings: drawingsUrls || "", // 确保有默认值
          carousel_images: carouselUrls || "",
          attachments: attachmentUrl || "",

          // 许可信息
          license_type: this.radio,
          payment_away: this.radio === "2" ? this.form.payment_away : "",
          exclusive_selling_price:
            this.radio === "3" ? this.form.exclusive_selling_price : "",

          // 富文本内容
          abstract: this.$refs.abstractEditor.getContent(),
          legal_status: this.$refs.legalStatusEditor.getContent(),
          claims: this.$refs.claimsEditor.getContent(),
          description: this.$refs.descriptionEditor.getContent(),

          // 其他分类信息
          industrial_classification: this.form.industrial_classification,
          classification_of_case_sources:
            this.form.classification_of_case_sources,
          patent_type: this.form.patent_type,
          patentee: this.form.patentee,
          license_fee: this.form.license_fee,
          license_payment_type: this.form.license_payment_type,
          license_term: this.form.license_term,
        };
        console.log("发布的表单数据为：", patentData);

        // 如果是编辑模式，添加ID
        if (this.isEditMode) {
          patentData.id = this.currentPatentId;
        }
        // 提交数据
        let response;
        if (this.isEditMode) {
          // 使用修改接口
          response = await this.updatePatentData(patentData);
        } else {
          // 使用创建接口
          response = await this.submitPatentData(patentData);
        }
        console.log("完整响应:", response.code);
        if (response.code === 1) {
          this.$message.success(
            response.msg || (this.isEditMode ? "专利修改成功" : "专利发布成功")
          );
          this.resetForm();
          // 如果是编辑模式，返回列表页
          if (this.isEditMode) {
            this.$router.push("/memberCenter/my-publications");
          }
        } else {
          this.$message.error(
            response.msg || (this.isEditMode ? "专利修改失败" : "专利发布失败")
          );
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error("提交过程中出现错误");
      } finally {
        this.uploadLoading = false;
      }
    },
    // 新增专用上传方法
    async uploadFiles(files, type) {
      if (!files || files.length === 0) return "";

      try {
        const urls = [];
        for (const file of files) {
          // 如果已经是URL字符串，直接使用
          if (typeof file === "string") {
            urls.push(file);
            continue;
          }

          // 如果是File对象，上传并获取URL
          const url = await this.uploadFile(file);
          if (url) urls.push(url);
        }
        return urls.join(",");
      } catch (error) {
        console.error(`${type}上传失败:`, error);
        return "";
      }
    },
    async uploadFile(file) {
      if (!file) return "";

      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = file.type.includes("image")
          ? await getUploadImage(formData)
          : await getUploadFile(formData);

        return response.data?.full_src || response.data?.src || "";
      } catch (error) {
        console.error("文件上传失败:", error);
        return "";
      }
    },
    async updatePatentData(data) {
      const formData = new FormData();

      // 将数据转换为 FormData
      Object.keys(data).forEach((key) => {
        // 处理富文本内容（避免被转义）
        const value =
          typeof data[key] === "string"
            ? data[key].replace(/"/g, '\\"')
            : data[key];
        formData.append(key, value);
      });

      return getUpdatePatent(formData);
    },
    async submitPatentData(data) {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        // 处理富文本内容（避免被转义）
        const value =
          typeof data[key] === "string"
            ? data[key].replace(/"/g, '\\"')
            : data[key];
        formData.append(key, value);
      });

      return getPublishPatent(formData);
    },
    // 新增删除方法
    removeDrawing(index) {
      this.form.drawings.splice(index, 1);
    },

    removeCarouselImage(index) {
      this.form.carousel_images.splice(index, 1);
    },
    // 重置表单
    resetForm() {
      this.form = {
        application_number: "",
        patent_classification: "",
        title: "",
        authorization_type: "",
        field: "",
        price_type: "",
        price: "",
        right_holder: "",
        current_right_holder: "",
        agent: "",
        priority_info: "",
        publication_number: "",
        publication_date: "",
        applicant_address: "",
        main_classification: "",
        ipc_classification: "",
        inventor: "",
        agency: "",
        industrial_classification: "",
        classification_of_case_sources: "",
        patent_type: "",
        patentee: "",
        license_fee: "",
        license_payment_type: "",
        license_term: "",
        drawings: [],
        carousel_images: [],
        attachments: null,
        payment_away: "",
        exclusive_selling_price: "",
      };
      this.radio = "1";
      // 安全地重置富文本编辑器
      this.$refs.abstractEditor.clearEditorContent();
      this.$refs.legalStatusEditor.clearEditorContent();
      this.$refs.claimsEditor.clearEditorContent();
      this.$refs.descriptionEditor.clearEditorContent();
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.image-upload-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.upload-placeholder {
  width: 109px;
  height: 109px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    // object-fit: contain;
  }
}

.image-preview {
  position: relative;
  width: 109px;
  height: 109px;

  img {
    width: 100%;
    height: 100%;
    // object-fit: contain;
    border: 1px solid #eee;
    border-radius: 4px;
  }

  .delete-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    background: #f56c6c;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;

    &:hover {
      background: #e74c3c;
    }
  }
}
.form {
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-bottom: 1px solid rgba(222, 222, 222, 1);
    padding: 12px 0 32px 0;
    li {
      // width: 33.3%;
      margin-top: 20px;
      margin-right: 80px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      // justify-content: flex-start;
      h2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #434343;
        margin-bottom: 15px;
        // text-align: left;
      }
      input {
        width: 259px;
        height: 43px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: none;
        outline: none;
        border: 1px solid #d8d9dc;
        padding-left: 13px;
        box-sizing: border-box;
      }
      input::placeholder {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #b1b1b1;
      }
      img {
        width: 109px;
        height: 109px;
        cursor: pointer;
      }
      .sort {
        ::v-deep .el-input__inner {
          width: 259px;
          height: 43px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #d8d9dc;
          padding: 0 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #121212;
        }
        ::v-deep .el-input__inner::placeholder {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #b1b1b1;
        }
      }
    }
  }
}
.home {
  padding-bottom: 56px;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    line-height: 28px;
    text-align: left;
    margin-left: 20px;
    margin-top: 20px;
  }
  .content1 {
    // width: 100%;
    margin: 0 35px;
    .editor {
      li {
        width: 100%;
        max-width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #434343;
          text-align: left;
          margin-bottom: 15px;
        }
      }
    }
    .footer {
      li {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        h2 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #434343;
          text-align: left;
          margin-bottom: 15px;
        }
        img {
          width: 109px;
          height: 109px;
          cursor: pointer;
        }
      }
      .choice {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #434343;
          text-align: left;
          margin-bottom: 15px;
        }
        .choice_content {
          display: flex;
          align-items: center;
          input {
            width: 259px;
            height: 43px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #d8d9dc;
            outline: none;
            padding-left: 13px;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #b1b1b1;
          }
          ::v-deep .el-radio__label {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #121212;
          }
          ::v-deep .el-radio__input.is-checked .el-radio__inner {
            background: #1c6fff;
            border: none;
          }
          ::v-deep .el-radio__inner::after {
            width: 4px;
            height: 10px;
            border: 2px solid #fff;
            border-left: 0;
            border-top: 0;
            transform: rotate(45deg) scale(1) translate(-50%, -50%);
            left: 29%;
            top: 45%;
            background-color: transparent;
            border-radius: 0; /* 移除圆角，使对号线条更直 */
          }
          ::v-deep .el-radio__inner {
            width: 20px;
            height: 20px;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 2px solid #bfbfbf;
            position: relative;
          }
        }
      }
      .upload {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #434343;
          text-align: left;
        }
        ul {
          margin-top: 15px;
          cursor: pointer;
          width: 107px;
          height: 32px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #d9d9d9;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #262626;
          }
        }
      }
      .form {
        ul {
          border-bottom: 0;
          padding-bottom: 0;
        }
        .borderB {
          padding-bottom: 32px;
          border-bottom: 1px solid #dedede;
        }
      }
    }
    .submit {
      cursor: pointer;
      width: 83px;
      height: 42px;
      background: #233cac;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border-radius: 5px;
      margin-top: 45px;
    }
  }
}
</style>
